import { Title, WithErrorBoundary, SingleLineText } from '@bloomays-lib/ui.shared';
import { styled } from '@mui/material/styles';
import ServiceJobTitle from '../../services/serviceJobTitles';
import LabelManagment from '../organisms/LabelManagment';

const Container = styled('div')(({ theme }) => ({
  width: '90%',
  margin: 'auto',
  [theme.breakpoints.down('md')]: {
    width: '80%',
  },
}));

const AdminJobTitleManagment = () => {
  const AdminJobTitle = ServiceJobTitle(LabelManagment);

  return (
    <div>
      <Title id="adminJobTitle" textTitle={'Administration des intitulés de postes'} />
      <SingleLineText id="descAdminJobTitle" text={'Administration des intitulés de poste et gestion des doublons'} />
      <Container>
        <AdminJobTitle />
      </Container>
    </div>
  );
};

export default WithErrorBoundary(AdminJobTitleManagment);
